import one360 from './one360';
import type {
  ProjektdokumentationFormData,
  ProjektdokumentationStatusUpdate,
  ProjektdokumentationStoredRecord,
  ProjektdokumentationTemplate,
  ProjektdokumentationUpsertResult,
} from '../../types/projektdokumentation';

export const getProjektdokumentationTemplate = async (
  projectId: string
): Promise<ProjektdokumentationTemplate> =>
  one360.get<ProjektdokumentationTemplate>(`/api/v1/ops/projects/${encodeURIComponent(projectId)}/projektdokumentation-template`);

export const upsertProjektdokumentation = async (
  projectId: string,
  payload: ProjektdokumentationFormData
): Promise<ProjektdokumentationUpsertResult> =>
  one360.put<ProjektdokumentationUpsertResult>(`/api/v1/ops/projects/${encodeURIComponent(projectId)}/projektdokumentation`, payload);

export const updateProjektdokumentationStatus = async (
  projectId: string,
  payload: ProjektdokumentationStatusUpdate
): Promise<ProjektdokumentationStoredRecord> =>
  one360.post<ProjektdokumentationStoredRecord>(`/api/v1/ops/projects/${encodeURIComponent(projectId)}/projektdokumentation/status`, payload);

export const resetVotToDraft = async (
  projectId: string
): Promise<ProjektdokumentationStoredRecord> =>
  one360.post<ProjektdokumentationStoredRecord>(
    `/api/v1/ops/projects/${encodeURIComponent(projectId)}/projektdokumentation/reset-to-draft`
  );
